import React from 'react';
import { Row } from '../../../lib/utils';
import { Body3Regular } from '../../../lib/font';
import { colors } from '../../../lib/colors';

const TopTable = () => {
    return (
        <Row
            style={{
                alignItems: 'center',
                width: 1100,
                height: 56,
                borderTop: '1px solid #c3d4f4',
                borderBottom: '1px solid #c3d4f4',
                paddingLeft: 12,
            }}
        >
            <Row style={{ width: 70.33 - 0.5, height: 32, alignItems: 'center', justifyContent: 'center' }}>
                <Body3Regular style={{ color: colors.LAVEL_3 }}>상태</Body3Regular>
            </Row>
            <div style={{ width: 1, height: 24, backgroundColor: colors.BLUE_100 }} />

            <Row style={{ width: 136.67 - 0.5, height: 32, alignItems: 'center', justifyContent: 'center' }}>
                <Body3Regular style={{ color: colors.LAVEL_3 }}>강사 이름</Body3Regular>
            </Row>
            <div style={{ width: 1, height: 24, backgroundColor: colors.BLUE_100 }} />

            <Row style={{ width: 136.67 - 0.5, height: 32, alignItems: 'center', justifyContent: 'center' }}>
                <Body3Regular style={{ color: colors.LAVEL_3 }}>회원 이름</Body3Regular>
            </Row>
            <div style={{ width: 1, height: 24, backgroundColor: colors.BLUE_100 }} />

            <Row style={{ width: 200.66 - 0.5, height: 32, alignItems: 'center', justifyContent: 'center' }}>
                <Body3Regular style={{ color: colors.LAVEL_3 }}>기존 수업 시간</Body3Regular>
            </Row>
            <div style={{ width: 1, height: 24, backgroundColor: colors.BLUE_100 }} />
            <Row style={{ width: 200.66 - 0.5, height: 32, alignItems: 'center', justifyContent: 'center' }}>
                <Body3Regular style={{ color: colors.LAVEL_3 }}>변경된 수업 시간</Body3Regular>
            </Row>
            <div style={{ width: 1, height: 24, backgroundColor: colors.BLUE_100 }} />

            <Row style={{ width: 228.67 - 0.5, height: 32, alignItems: 'center', justifyContent: 'center' }}>
                <Body3Regular style={{ color: colors.LAVEL_3 }}>취소 사유</Body3Regular>
            </Row>
            <div style={{ width: 1, height: 24, backgroundColor: colors.BLUE_100 }} />

            <Row style={{ width: 126.33, height: 32, alignItems: 'center', justifyContent: 'center' }}>
                <Body3Regular style={{ color: colors.LAVEL_3 }}>취소/변경 횟수</Body3Regular>
            </Row>
        </Row>
    );
};

export default TopTable;
